import {
  COMMISSIONS_GET_AVAILABLE_PERIODS_BEGIN,
  COMMISSIONS_GET_AVAILABLE_PERIODS_SUCCESS,
  COMMISSIONS_GET_AVAILABLE_PERIODS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_AVAILABLE_PERIODS_BEGIN:
      return {
        ...state,
        policies: {
            ...state.policies,
            commissionsMonths: [],
            getCommissionsMonthPending: true
        }
      }
    case COMMISSIONS_GET_AVAILABLE_PERIODS_SUCCESS:
      return {
        ...state,
        policies: {
            ...state.policies,
            commissionsMonths: action.data.commissionsMonths,
            getCommissionsMonthPending: false
        }
      }

    case COMMISSIONS_GET_AVAILABLE_PERIODS_FAILURE:
      return {
        ...state,
        policies: {
            ...state.policies,
            commissionsMonths: [],
            getCommissionsMonthPending: false
        }
      }
    default:
      return state
  }
}
